import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import {
  ContactUsWidgetService,
  SupportRequestService,
  AbstractSupportConfigService,
} from './services';
import { TicketCreationSuccessComponent } from './components';
import { ModalsModule } from '@anecdotes/design-system/modals';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SmoochSdkFacade } from './services/smooch-sdk-facade/smooch-sdk-facade.service';

@NgModule({
  imports: [ModalsModule, ButtonsModule, SvgIconsModule, CommonModule, TranslateModule],
  declarations: [TicketCreationSuccessComponent],
  providers: [],
})
export class SupportModule {
  static forRoot(configType: Type<AbstractSupportConfigService>): ModuleWithProviders<SupportModule> {
    return {
      ngModule: SupportModule,
      providers: [
        { provide: AbstractSupportConfigService, useClass: configType },
        ContactUsWidgetService,
        SmoochSdkFacade,
        SupportRequestService,
      ],
    };
  }
}
